import React from 'react';
import { Icon } from './Icon.js';
export const IconMouse2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 2V11", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M4 11H20", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M4 10L4 14C4 18.4183 7.58172 22 12 22C16.4183 22 20 18.4183 20 14L20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconMouse2.js.map